import * as eff from 'redux-saga/effects';

import {
  actionTypes,
} from 'web-actions';

function* confirmModal({
  onError,
  onSuccess,
  onCancel,
  onConfirm,
  onCancelAction,
  onConfirmAction,
}) {
  const { ok } = yield eff.race({
    ok: eff.take(actionTypes.OK_CONFIRM_MODAL),
    cancel: eff.take(actionTypes.CANCEL_CONFIRM_MODAL),
  });

  if (ok) {
    const {
      closeModal,
      callbacks,
    } = ok;

    const cb = () => {
      callbacks?.setSubmitting?.(false);
      closeModal();
    };

    if (onConfirmAction) {
      yield eff.put({
        ...onConfirmAction,
        callbacks: {
          onError: (e: any) => {
            cb();
            onError?.(e);
            onConfirmAction.callbacks?.onError?.(e);
          },
          onSuccess: (data: any) => {
            cb();
            onSuccess?.(data);
            onConfirmAction.callbacks?.onSuccess?.(data);
          },
        },
      });
    } else if (onConfirm) {
      cb();
      onConfirm();
    } else {
      cb();
    }

    return;
  }

  if (onCancel) onCancel();
  if (onCancelAction) yield eff.put(onCancelAction);
}

function* searchVideoModal({ onAssign, onCancel, onUploaded }) {
  const { assign, uploaded } = yield eff.race({
    cancel: eff.take(actionTypes.CANCEL_SEARCH_VIDEO_MODAL),
    assign: eff.take(actionTypes.ASSIGN_SEARCH_VIDEO_MODAL),
    uploaded: eff.take(actionTypes.ON_UPLOADED_VIDEO_SUCCESS),
  });

  if (assign && onAssign) {
    onAssign(assign.video);
    return;
  }

  if (uploaded && onUploaded) {
    onUploaded(uploaded.video);
    return;
  }

  if (onCancel) onCancel();
}

function* exercisePicker({ onSelect, onCancel }) {
  const { select } = yield eff.race({
    select: eff.take(actionTypes.SELECT_EXERCISE_PICKER),
    cancel: eff.take(actionTypes.CANCEL_EXERCISE_PICKER),
  });

  if (select) onSelect(select.exerciseId);
  else if (onCancel) onCancel();
}

function* moveEntityModal({ onCancel, onSelect }) {
  const { select } = yield eff.race({
    select: eff.take(actionTypes.SELECT_MOVE_ENTITY_MODAL),
    cancel: eff.take(actionTypes.CANCEL_MOVE_ENTITY_MODAL),
  });

  if (select) onSelect(select.values, select.actions);
  else if (onCancel) onCancel();
}

export default function* watchingTasks() {
  yield eff.takeEvery(actionTypes.CONFIRM_MODAL, confirmModal);
  yield eff.takeEvery(actionTypes.MOVE_ENTITY_MODAL, moveEntityModal);
  yield eff.takeEvery(actionTypes.SEARCH_VIDEO_MODAL, searchVideoModal);
  yield eff.takeEvery(actionTypes.OPEN_EXERCISE_PICKER, exercisePicker);
}
